import template from './manage-sms-notification-edit.html';

@Inject('Notifications', 'appFactory')
class ManageSmsNotificationViewController {
  $onChanges(changes) {
    if (changes.smsEnabled) {
      this.smsEnabled = !!this.smsEnabled;
    }
  }

  applySmsNotifications(data) {
    if (data.smsEnabled) {
      this.onShowSmsPolicy();
    }
    this.applyChanges(data);
  }

  onShowSubscriptionDialog() {
    if (!this.disabled) {
      return this.showSubscriptionDialog();
    }
  }

  onShowSmsPolicy() {
    this.showSmsPolicy.run();
  }
}

export default class ManageSmsNotificationViewComponent {
  constructor() {
    this.controller = ManageSmsNotificationViewController;
    this.template = template;
    this.bindings = {
      smsEnabled: '<',
      disabled: '<',
      smsPolicy: '<',
      applyChanges: '&',
      showSubscriptionDialog: '&',
      showSmsPolicy: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/sms/components/manage-sms-notification/components/manage-sms-notification-edit/manage-sms-notification-edit-component.js